exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-cascader-menu-item:hover {\n  background: #F5F7FA;\n}\n", ""]);

// exports
